<template>
  <div class="couponBanner">
    <div class="couponBannerBox">
      <div
        class="cssBanner"
        :style="{background: '#e05283 url('+cssBannerStyle.url+') no-repeat',backgroundSize:'cover'}"
      >
        <div class="mainContainer">
          <div class="row">
            <div class="coupon_rightContentBox col-12 order-sm-12 col-sm-8">
              <div class="coupon_swiperBox">
                <splide
                  :options="options"
                  ref="splideBox"
                  @splide:moved="moved"
                >
                  <!-- <splide-slide v-for="(slide,index) in slidesList" :key="slide.id" :id="index" :style="splideImgWidth" class="ppppppp">
                    <a :href="slide.referenceLink" target="_black">
                        <img :src="'/Events/retrieveEventBannerLargeImage.do?id=' + slide.id" alt="slide.alt" :ref="'splideBoxImg'+ index"  :style="splideImgWidth">
                    </a>
                </splide-slide> -->
                  <splide-slide class="ppppppp">
                    <img
                      src="@/assets/images/banner_test.jpg"
                      class="img-fluid"
                      alt="slide.alt"
                    >
                  </splide-slide>
                  <splide-slide class="ppppppp">
                    <img
                      src="@/assets/images/banner_test.jpg"
                      class="img-fluid"
                      alt="slide.alt"
                    >
                  </splide-slide>
                  <splide-slide class="ppppppp">
                    <img
                      src="@/assets/images/banner_test.jpg"
                      class="img-fluid"
                      alt="slide.alt"
                    >
                  </splide-slide>
                  <splide-slide class="ppppppp">
                    <img
                      src="@/assets/images/banner_test.jpg"
                      class="img-fluid"
                      alt="slide.alt"
                    >
                  </splide-slide>
                </splide>
              </div>
            </div>
            <div class="coupon_leftContentBox col-12 order-sm-1 col-sm-4">
              <div class="block">
                <div class="coupon_leftContentBox_mainTitle">
                  <span class="coupon_leftContentBox_title">Rabbitzhop 精選Voucher:</span>
                  <span class="coupon_leftContentBox_text">MUJI GIFT</span>
                  <span class="coupon_leftContentBox_text">$100 禮品卡</span>
                </div>

                <div class="couponBoxVerbar"></div>
                <div class="coupon-promotion-info row">
                  <div class="coupon_leftContentBox_subtitle col-12">
                    <div class="couponBox_price_wrap">
                      <div class="newPrice">
                        <span>$</span>
                        <strong>{{newPrice}}</strong>
                      </div>
                      <span class="oldPrice">${{oldPrice}}</span>
                    </div>
                    <div class="couponBox_info_wrap">
                      <button class="disCountBtn">{{disCountValue}}% Off</button>
                      <div class="info-buyers">
                        <i class="iconfont icon-yonghu"></i>
                        {{buyers}}K+已售
                      </div>
                    </div>
                  </div>
                  <div class="col-12"><button class="coupon_redeem_button"><i class="iconfont icon-shopping"></i>Purchase Now!</button></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@/assets/css/splide.min.css'
export default {

  name: 'CanvasRebbin',
  components: {
    Splide,
    SplideSlide
  },
  data () {
    return {
      indent_style: '',
      validity_period: '05/01/2020 ~ 12/12/2020',
      coupons: [{ couponBannerUrl: '' }],
      cssBannerStyle: {
        url: require('@/assets/images/bg.svg')
      },
      wrapper: {
        url: require('@/assets/images/chop.svg')
      },
      options: {
        type: 'loop',
        speed: 800,
        autoplay: true,
        interval: 5000,
        start: 0,
        drag: 'false',
        arrows: false
      },
      newPrice: 50,
      oldPrice: 100,
      buyers: 4.9,
    }
  },
  computed: {
    disCountValue () {
      return this.newPrice / this.oldPrice * 100 + '%'
    }
  },
  methods: {
    moved (splide, newIndex) {
      console.log('moved', newIndex);
    }
  },
  mounted () {
  },
  destroyed () {

  }
}
</script>
<style scoped>
.couponBannerBox {
  position: relative;
  margin: 0px 0px;
}
.couponBannerBox .cssBanner {
  color: white;
  position: relative;
}

.coupon_leftContentBox {
  color: #ffffff;
  padding: 0 40px 0 0;
  position: relative;
  display: flex;
  align-items: center;
  text-align: left;
  transition-duration: 0.5s;
}
.coupon_leftContentBox_mainTitle {
  display: flex;
  flex-direction: column;
}

.coupon_leftContentBox_title {
  margin-bottom: 10px;
}

.coupon_leftContentBox_text {
  font-style: normal;
  font-weight: 300;
  font-size: 36px;
  line-height: 1.2;
}

.couponBoxVerbar {
  width: 100%;
  border-bottom: 1px dotted #fff;
  margin: 12px 0 12px;
}
.couponBox_percentage {
  font-size: 4em;
  line-height: 1;
  font-weight: 800;
  vertical-align: top;
  display: inline-block;
}
.coupon-promotion-info.row {
  margin: 0 -15px;
}

.coupon_leftContentBox_subtitle {
  position: relative;
  display: flex;
  justify-content: space-between;
}
.coupon_leftContentBox_subtitle .couponBox_price_wrap,
.coupon_leftContentBox_subtitle .couponBox_info_wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.coupon_leftContentBox_subtitle .couponBox_price_wrap .newPrice span {
  display: inline-block;
  font-size: 20px;
}
.coupon_leftContentBox_subtitle .couponBox_price_wrap .newPrice strong {
  display: inline-block;
  font-size: 36px;
  margin-top: -15px;
}

.coupon_leftContentBox_subtitle .couponBox_price_wrap .oldPrice {
  font-size: 16px;
  text-decoration-line: line-through;
}

.coupon_leftContentBox_subtitle .couponBox_info_wrap .disCountBtn {
  border: 1px solid #ffffff;
  border-radius: 30px;
  font-size: 13px;
  background: transparent;
  outline: none;
}
.coupon_leftContentBox_subtitle .couponBox_info_wrap .disCountBtn:active {
  opacity: 0.9;
}

.coupon_leftContentBox_subtitle .couponBox_info_wrap .info-buyers {
  display: inline-block;
  font-size: 16px;
}

.coupon_redeem_button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 10px;
  padding: 0px 15px;
  border: 0;
  font-size: 17px;
  color: #e05283;
  background: #ffffff;
  border-radius: 3px;
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.coupon_redeem_button .iconfont {
  font-size: 30px;
  margin-right: 5px;
}

.coupon_redeem_button:hover {
  background: #d6d6d6;
}

.coupon_redeem_button:focus {
  outline: none;
}

.coupon_swiperBox {
  position: relative;
  top: 50px;
  transition-duration: 0.5s;
  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.splide__slide img {
  width: 100%;
}

@media (max-width: 1650px) and (min-width: 1400px) {
  .coupon_swiperBox {
    right: 50px;
  }
}
@media (max-width: 1400px) and (min-width: 1025px) {
  /*.coupon_swiperBox {
    width: 740px;
    height: 0px;
    right: 0px;
  }*/
}

@media (max-width: 767px) {
  .coupon_rightContentBox {
    padding: 0;
    margin-bottom: 20px;
  }
  .coupon-promotion-info {
    padding: 0 0 20px 0;
  }
  .block {
    display: block;
    width: 100%;
  }

  .coupon_leftContentBox {
    padding: 0 20px;
    margin-top: 0px;
  }
  .coupon_leftContentBox_mainTitle {
    display: block;
  }
  .coupon_leftContentBox_text {
    font-size: 20px;
  }
  .coupon_leftContentBox_title {
    margin-bottom: 5px;
    font-size: 14px;
    display: block;
  }

  .coupon_leftContentBox_subtitle {
    position: relative;
  }

  .couponBox_percentage {
    font-size: 2.6rem;
  }

  .coupon_redeem_button {
    padding: 0px 5px;
    margin-top: 5px;
    font-size: 16px;
  }

  .coupon_swiperBox {
    width: 100%;
    height: auto;
    position: relative;
    top: 0px;
    right: 0px;
  }

  .splide__pagination {
    position: absolute;
    z-index: 1;
    bottom: 0.5em !important;
    left: 14% !important;
    transform: translateX(-50%);
    padding: 0;
  }
}

@media (min-width: 768px) and (max-width: 1280px) {
  .couponBox_percentage {
    font-size: 3em;
    vertical-align: top;
  }
  .coupon_leftContentBox_text {
    font-size: 20px;
  }
  .coupon_redeem_button {
    padding: 5px 15px;
    margin-top: 10px;
  }
  .couponBannerBox .cssBanner {
    padding: 0 30px;
  }
  .coupon_swiperBox {
    top: 0px;
  }
  .coupon_leftContentBox {
    padding: 20px 0;
  }
  .splide__pagination__page {
    bottom: 15px !important;
  }
}

@media (min-width: 1280px) and (max-width: 1366px) {
  .coupon_leftContentBox {
    padding: 40px 0;
  }
  .coupon_leftContentBox_text {
    font-size: 30px;
  }
}
</style>
